import { ITeamMember } from '@/types';
import { getUrl } from '@/utils/api';

function useTeamMembers(filter?: string) {
  let url = `v1/team_members`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as ITeamMember[],
  };
}

export default useTeamMembers;
